import { render, staticRenderFns } from "./MdQuestionMark.vue?vue&type=template&id=f32a5e92"
import script from "./MdQuestionMark.vue?vue&type=script&lang=ts"
export * from "./MdQuestionMark.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports